const BASE = import.meta.env.VITE_APP_BASE_PATH || "";

const ROUTES = {
  ROOT: `${BASE}/`,
  AUTH: {
    ROOT: `${BASE}/auth`,
    LOGIN: `${BASE}/Authentication/AuthLogin/login`,
    FORGOT_PASSWORD: `${BASE}/forget-password`,
    REGISTER: `${BASE}/sign-up`,
  },
  DASHBOARD: `${BASE}/dashboard`,
  CHARTS: `${BASE}/charts`,
  ORDERS: {
    VIEW: `${BASE}/orders-view`,
    CREATE: `${BASE}/order-create`,
    SUMMARY: `${BASE}/order-summary`,
    AUTO_CREATE: `${BASE}/order-create-automation`,
    BULK_ORDER_CREATE: `${BASE}/order-create-bulk`,
    DOMAIN_TRANSFER: `${BASE}/domain-transfer`,
    DOMAIN_MANAGEMENT: `${BASE}/domain-management`,
    DOMAIN_DETAIL: `${BASE}/domain-management/:domainName`
  },
  EMAIL: {
    ACCOUNTS: `${BASE}/email-accounts`,
  },
  CUSTOMERS: {
    VIEW: `${BASE}/customers-view`,
    DETAILS: `${BASE}/customer-details`,
  },
  BILLING: {
    INVOICES: `${BASE}/invoices-view`,
    PROMO: `${BASE}/view-promo-code`,
    REFERRALS: `${BASE}/view-referrals`,
    AFFILIATE_REQUESTS: `${BASE}/affiliate-requests`,
  },
  SUPPORT_OLD: {
    TICKET: `${BASE}/v1/ticket`,
    TICKET_CHAT: `${BASE}/ticket-chat`
  },
  SUPPORT: {
    TICKET: `${BASE}/ticket`,
    CHAT: `${BASE}/ticket/:ticketId`,
    HELP_GUIDES: `${BASE}/help-guides`,
    HELP_GUIDES_OUTSIDE: `${BASE}/help`,
    METRICS: `${BASE}/metrics`,
    TAXONOMY: `${BASE}/support/taxonomy`,
    MACROS: `${BASE}/support/macros`,
    TEMPLATES: `${BASE}/support/templates`,
    SLA: `${BASE}/support/sla`,
    ALERTS: `${BASE}/support/alerts`,
    AGENTS: `${BASE}/support/agents`,
    INTEGRATIONS: `${BASE}/support/integrations`,
  },
  ADDONS: {
    EMAIL_VERIFIER: `${BASE}/email-verifier`,
    CALCULATOR: `${BASE}/calculator`,
    SPAM: `${BASE}/spam-checker`,
    REGISTER_CREDENTIALS: `${BASE}/register-credentials`,
    PREWARM: `${BASE}/prewarm`,
    PREWARM_CHECKOUT: `${BASE}/prewarm/checkout`,
    PREWARM_DETAIL: `${BASE}/prewarm/detail`,
    SEQUENCERS: `${BASE}/sequencers`,
    ADMIN_SEQUENCERS: `${BASE}/admin-sequencers`,
    AFFILIATE: `${BASE}/affiliate`,
    PARTNER_WALLET: `${BASE}/partner/wallet/:partnerId/details`,
    WALLET: `${BASE}/wallet`,
    WALLET_DETAIL: `${BASE}/wallet/:walletId/details`,
    AUDITLOG: `${BASE}/audit-logs`,
    MONITORING: `${BASE}/api-monitoring`
  },
  WORKSPACE: {
    JOBS: `${BASE}/workspace-provisioning`,
  },
  DOMAIN_RENEWAL: `${BASE}/domain-renewal`,
  PAYMENTS: {
    PROCESS: `${BASE}/payment`,
    SUCCESS: `${BASE}/success`,
    FAILED: `${BASE}/failed`,
  },
  REPORTS: `${BASE}/reports`,
  SETTINGS: `${BASE}/settings`,
  API_DOCS: `${BASE}/api-documentation`,
  // Permanent file download link sent in emails.
  DOWNLOAD_LINK: `${BASE}/downloads/:token`,
  SUPPORTWITHOUTLOGIN: `${BASE}/support/ticket`,
  OLD_EXPOSED_API: `${BASE}/old-api-documentation`,
  ERRORS: {
    _403: `${BASE}/error403`,
    _404: `${BASE}/error404`,
    _500: `${BASE}/error500`,
    DENIED: `${BASE}/`,
  },
};

export default ROUTES;
